import React from 'react';
import './Question.css'

const AnswerYes = () => {
    return <div>
        <p>
            Instead of overwriting data, recording additional updates creates 
            new information while also keeping the original data intact.
        </p> 
    </div>
}

const AnswerNo = () => {
    return <div>
        <p>
            Keeping data unchanged and adding only a record of all changes 
            allows accurate referencing of both new and existing information.
        </p>
    </div>
}

const Answer = (props) => {
    if (props.answer === 'answerYes') {
        return <AnswerYes />
    } else if (props.answer === 'answerNo') {
        return <AnswerNo />
    } else {
        return <p>Please click an answer button above.</p>
    }
}

class QImmut extends React.Component {
    constructor(props) {
        super(props);
        this.state = {question: 'unanswered'};
    }
    render() {
        return <div className="Question">
            <p>
                Immutability means never changing data?
            </p>
            <br/>
            <div>
                <span className="Button Affirmative" 
                onClick={()=> this.setState({question: 'answerYes'})}
                > Yes </span>
                <span className="Button Negative"
                onClick={()=> this.setState({question: 'answerNo'})}                
                >No</span>
            </div>
            <br/>
            <Answer answer={this.state.question} />
        </div>
    }
}

export default QImmut;


// WEBPACK FOOTER //
// ./src/components/q_immut.js